import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.location');
import { ChangeDetectorRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { KioskContext, MEETING_ROOMS, MeetingLocation, MeetingRoom, RoomNo } from "src/libs/portal/kiosk/context";

@Component({
    selector: 'wiz-portal-kiosk-location',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.location/view.scss */
:host {
  display: block;
}`],
})
export class PortalKioskLocationComponent implements OnInit, OnDestroy {
    @Input() allowClose: boolean = false;
    @Output() locationChange = new EventEmitter<MeetingLocation>();
    @Output() closed = new EventEmitter<void>();

    public meetingRooms: MeetingRoom[] = MEETING_ROOMS;
    public selectedRoomNo: RoomNo | null = null;
    public selectedPlaceName: string | null = null;
    public currentLocation: MeetingLocation | null = null;
    public timeText: string = '--:--';
    public dateText: string = '';

    private clockTimer: any = null;
    private destroyed: boolean = false;

    constructor(@Inject( ChangeDetectorRef) private ref: ChangeDetectorRef) { }

    public ngOnInit() {
        this.currentLocation = KioskContext.loadMeetingLocation();
        this.selectedRoomNo = this.currentLocation ? this.currentLocation.room : null;
        this.selectedPlaceName = this.currentLocation ? this.currentLocation.place : null;
        this.updateClock();
        this.clockTimer = setInterval(() => this.updateClock(), 1000 * 30);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.clockTimer) clearInterval(this.clockTimer);
    }

    public get selectedRoomPlaces() {
        return KioskContext.getRoomPlaces(this.selectedRoomNo);
    }

    public selectRoom(room: MeetingRoom) {
        if (!room) return;

        this.selectedRoomNo = room.id;
        this.selectedPlaceName = null;
        this.render();
    }

    public selectPlace(place: string) {
        if (!this.selectedRoomNo || !place) return;

        const location = KioskContext.createMeetingLocation(this.selectedRoomNo, place);
        if (!location) return;

        this.selectedPlaceName = place;
        this.currentLocation = location;
        KioskContext.storeMeetingLocation(location);
        this.locationChange.emit(location);
        this.render();
    }

    public close() {
        if (!this.allowClose) return;
        this.closed.emit();
    }

    private updateClock() {
        const clock = KioskContext.clockText();
        this.timeText = clock.timeText;
        this.dateText = clock.dateText;
        this.render();
    }

    private render() {
        if (this.destroyed) return;

        setTimeout(() => {
            if (this.destroyed) return;
            this.ref.detectChanges();
        }, 0);
    }
}

export default PortalKioskLocationComponent;